import { Component, OnInit} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Producto } from '../producto.model';
import { ClienteService } from '../../core/cliente.service';
import { DomSanitizer } from '@angular/platform-browser';
import { Observable } from 'rxjs/Observable';
import { DialogService } from '../../shared-components/modals/dialog.service';
import { SnackService } from '../../shared-services/snack.service';
import { BackendService } from '../../core/backend.service';
import { CategoriaProducto } from '../categoria-producto/categoria-producto.model';
import { SubcategoriaProducto } from '../subcategoria-producto/subcategoria-producto.model';
import { Sugerencia } from '../sugerencia/sugerencia.model';
import { Checkeable } from './checkeable.model';
import { NavigationService } from '../../shared-services/navigation.service';

@Component({
  selector: 'app-producto-validar-datos',
  templateUrl: './producto-validar-datos.component.html',
  styleUrls: ['./producto-validar-datos.component.scss']
})
export class ProductoDValidarDatosComponent implements OnInit {

  producto: Producto;
  imagen: any;
  observable: Observable<string[]>;
  primera = true;
  categoriasExternas: Checkeable<CategoriaProducto>[] = [];
  subcategoriasExternas: Checkeable<SubcategoriaProducto>[] = [];
  sugerenciasExternas: Checkeable<Sugerencia>[] = [];

  constructor(
    private route: ActivatedRoute,
    private navigationService: NavigationService,
    private dialogService: DialogService,
    private snackService: SnackService,
    private backendService: BackendService,
    public router: Router  ) { }

  ngOnInit() {
    this.refreshData();
  }
  refreshData(): any {
    this.categoriasExternas = [];
    this.subcategoriasExternas = [];
    this.sugerenciasExternas = [];
    this.getCategorias();
    this.getSubcategorias();
    this.getSugerencias();
  }
  async getCategorias() {
    this.backendService.get(CategoriaProducto, CategoriaProducto.path + 'externas', {}).toPromise().then(data => {
      data.forEach(e => {
        this.categoriasExternas.push(new Checkeable<CategoriaProducto>(e));
      });
    });
  }
  async getSubcategorias() {
    this.backendService.get(SubcategoriaProducto, SubcategoriaProducto.path + 'externas', {}).toPromise().then(data => {
      data.forEach(e => {
        this.subcategoriasExternas.push(new Checkeable<SubcategoriaProducto>(e));
      });
    });
  }
  async getSugerencias() {
    this.backendService.get(Sugerencia, Sugerencia.path + 'externas', {}).toPromise().then(data => {
      data.forEach(e => {
        this.sugerenciasExternas.push(new Checkeable<Sugerencia>(e));
      });
    });
  }

  onChange(event, ids: number[]) {
    if (event.checked) {
      ids.push(event.source.value);
    } else {
      const i = ids.findIndex(x => x === event.source.value);
      ids.splice(i, 1);
    }
  }

  selectAll(event, items: Checkeable<any>[]) {
    items.forEach(i => {
      i.checked = event.checked;
    });
  }

  async aceptarTodo() {
    this.dialogService.confirm('Validar datos externos',
    '¿Está seguro que desea aceptar todos los datos seleccionados?')
    .then( res => {
      if (res) {
        this.save(res, 'aceptar');
      }
    });
  }
  async descartarTodo() {
    this.dialogService.confirm('Validar datos externos',
    '¿Está seguro que desea rechazar todos los datos externos seleccionados?')
    .then( res => {
      if (res) {
        this.save(res, 'descartar');
      }
    });
  }

  back() {
    this.navigationService.back();
  }

  async save(res, operation) {
    if (res) {

      this.snackService.spinner(true);

      try {
        this.producto = this.backendService.new(Producto);
        this.producto.categorias = [];
        this.producto.subcategorias = [];
        this.producto.sugerencias = [];
        this.categoriasExternas.filter(e => e.checked).forEach(i => this.producto.categorias.push(i.inner));
        this.subcategoriasExternas.filter(e => e.checked).forEach(i => this.producto.subcategorias.push(i.inner));
        this.sugerenciasExternas.filter(e => e.checked).forEach(i => this.producto.sugerencias.push(i.inner));

        await await this.backendService.update(Producto.path + 'validar/' + operation, this.producto);
        this.snackService.success('Datos modificados satisfactoriamente');
        this.refreshData();
      } catch (ex) {
        if (ex[0]) {
          this.snackService.error(ex[0].details);
        } else if (ex.errors) {
          this.snackService.error(ex.errors[0].defaultMessage);
        } else {
          this.snackService.error(ex.message);
        }
      } finally {
        this.snackService.spinner(false);
      }
    }

  }


}



// WEBPACK FOOTER //
// ./src/app/productos/producto-validar-datos/producto-validar-datos.component.ts